import axiosInstance from "@/api/axios-instance";

export async function createSessionDocument(sessionId: string) {
  const response = await axiosInstance.post(`/document/create/session/${sessionId}`);
  
  if (!response.data.success) {
    throw new Error(response.data.error || "Failed to create document");
  }
  
  return response.data;
} 